import { FC, useEffect } from "react"
import SelectRangeDate from "./SelectRangeDate"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { hotelActions } from "@/lib/redux/features/hotel/reduce"
import dayjs from "dayjs"

type SelectCheckInOutProps = {
  size?: "small" | "default"
  /** URL/SSR dates — used on first paint before Redux is seeded */
  initialDates?: [string?, string?]
}

const SelectCheckInOut: FC<SelectCheckInOutProps> = ({ size = 'default', initialDates }) => {
  const [startDate, endDate] = useAppSelector(state => {
    return [state.hotel.formSearch.checkInDate, state.hotel.formSearch.checkOutDate]
  })
  const dispatch = useAppDispatch()
  const initialCheckIn = initialDates?.[0] || ''
  const initialCheckOut = initialDates?.[1] || ''
  const checkIn = startDate || initialCheckIn
  const checkOut = endDate || initialCheckOut

  useEffect(() => {
    // Skip defaulting when URL/SSR already provided dates.
    if (startDate || initialCheckIn) return
    dispatch(hotelActions.selectDateCheckIn(dayjs().add(15, 'day').format('YYYY-MM-DD')))
    dispatch(hotelActions.selectDateCheckOut(dayjs().add(16, 'day').format('YYYY-MM-DD')))
  }, [startDate, initialCheckIn, dispatch])

  return (
    <SelectRangeDate
      size={size}
      value={[checkIn, checkOut]}
    />
  )
}

export default SelectCheckInOut
